module.exports = __webpack_public_path__ + "img/norcott_b2.6c2c432d.jpg";